import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { AgGridFilterOption } from 'core/enums';
import { IPartFinderCatalogFamily } from 'partFinder/types';

import { FamilyNameCell } from './FamilyNameCell';
import { ManufacturersCell } from './ManufacturersCell';
import { SourceCell } from './SourceCell';

export const getColumnDefs = (): ColDef<IPartFinderCatalogFamily>[] => [
  {
    colId: 'name',
    headerName: t('headerName'),
    field: 'name',
    filter: 'agTextColumnFilter',
    cellRenderer: FamilyNameCell,
    // One family per name: nothing to group.
    enableRowGroup: false,
    flex: 3,
    minWidth: 240,
    sort: 'asc',
  },
  {
    colId: 'manufacturers',
    headerName: t('headerManufacturer'),
    valueGetter: ({ data }) => data?.manufacturers?.map(({ name }) => name).join(', ') ?? '',
    filter: 'agTextColumnFilter',
    cellRenderer: ManufacturersCell,
    flex: 2,
    minWidth: 220,
  },
  {
    colId: 'source',
    headerName: t('headerSource'),
    // Part Finder is the only kind of family there is for now.
    valueGetter: () => t('labelPartFinderSource'),
    cellRenderer: SourceCell,
    filter: 'agTextColumnFilter',
    enableRowGroup: false,
    flex: 1,
    minWidth: 140,
  },
  {
    colId: 'partsCount',
    headerName: t('headerParts'),
    field: 'partsCount',
    filter: 'agNumberColumnFilter',
    // A count is filtered as "at least".
    filterParams: { defaultOption: AgGridFilterOption.GREATER_THAN_OR_EQUAL },
    type: 'rightAligned',
    minWidth: 110,
  },
];
